module.exports = __webpack_public_path__ + "static/media/VPM_desktop_3.7d0f10ba.jpg";